import { Outlet, ScrollRestoration } from "react-router";
import { Header } from "./Header";
import { Footer } from "./Footer";

/**
 * Shared chrome wrapper for all public routes.
 *
 * Ported from web/src/components/layout/SiteChrome.tsx — renders Header and
 * Footer around the active route's element via <Outlet />. Header/Footer
 * own their own hidden-path logic.
 */
export function RootLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      {/* SPA navigations keep the window scroll position by default —
          without this, a long page's scroll offset carries onto the next
          route. Scrolls to top on new navigations, restores on back/forward. */}
      <ScrollRestoration />
    </>
  );
}
